
import { defineComponent, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import BaseRoundRectButton from "@/components/atoms/BaseRoundRectButton.vue";
import TextField from "@/components/atoms/TextField.vue";
import { LocalizationError } from "@/error/error";
import { CommunicationState } from "@/type";

export default defineComponent({
  name: "PasswordResetConfirmScreen",
  components: {
    BaseRoundRectButton,
    TextField,
  },
  props: {
    localizationError: {
      type: Object as () => LocalizationError | null,
      default: null,
      required: false,
    },
    communicationState: {
      type: Object as () => CommunicationState,
      default: 1,
      required: true,
    },
    isTokenValid: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  emits: {
    confirmPasswordReset: (request: { newPassword: string; confirmPassword: string }) => {
      if (request != null) return true;
    },
  },
  setup(props, { emit }) {
    const router = useRouter();

    const state = reactive({
      newPassword: "",
      confirmPassword: "",
      validationError: "",
    });

    const isLoading = ref<boolean>(false);

    watch(
      () => props.communicationState,
      () => {
        if (props.communicationState === 2) {
          isLoading.value = true;
        } else {
          isLoading.value = false;
        }
      }
    );

    function validatePassword(password: string): boolean {
      // 6〜20文字、英字と数字の両方を含む
      const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/;
      return regex.test(password);
    }

    function handleSubmit() {
      state.validationError = "";

      if (!state.newPassword) {
        state.validationError = "新しいパスワードを入力してください";
        return;
      }

      if (!validatePassword(state.newPassword)) {
        state.validationError = "パスワードは半角のアルファベットと数字両方を含む6〜20文字で入力してください";
        return;
      }

      if (!state.confirmPassword) {
        state.validationError = "確認用パスワードを入力してください";
        return;
      }

      if (state.newPassword !== state.confirmPassword) {
        state.validationError = "パスワードが一致しません";
        return;
      }

      emit("confirmPasswordReset", {
        newPassword: state.newPassword,
        confirmPassword: state.confirmPassword,
      });
    }

    function goToPasswordReset() {
      router.push("/password-reset");
    }

    return {
      state,
      isLoading,
      handleSubmit,
      goToPasswordReset,
    };
  },
});
